import AddressForm from '../form/address_form';
import loadAdyenDropin from './load_adyen_dropin.js';

function loadBillingAddress(callback = null) {
    let slAccountCode = $('select[name="slAccountCode"]').val();
    axios.get(`/my-basket/ajax/load-billing-address/sl-account/${slAccountCode}`).then(response => {
        let [billingAddress] = response.data;

        $('.default_billing--options .default-address').html(`
            <li>${billingAddress.addressLine1}</li>
            <li>${billingAddress.addressLine2 ?? ''}</li>
            <li>${billingAddress.city}</li>
            <li>${billingAddress.postCode}</li>
            <li>${billingAddress.country}</li>
        `);
        $('.billing-address .add_edit_manage--btn').attr('data-id', billingAddress.id);
        if (callback) {
            callback(billingAddress);
        }
    });
}

export default function initializeBillingAddressForm() {
    // Assuming jQuery and AddressForm are globally available or imported if needed.
    const $billingaddressFormFields = $('#billingAddressForm .form-fields');
    $billingaddressFormFields.removeClass('d-none');
    $billingaddressFormFields.find('button.new-btn').removeClass('small');
    $billingaddressFormFields.find('div:last')
        .removeClass('justify-content-between')
        .addClass('justify-content-end')
        .find('button:last').remove();

    const BillingAddressFormId = "#billingAddressForm";
    let BillingAddressForm = new AddressForm({
        form_id: BillingAddressFormId,
        read_url: `/billing-address/read`,
    });

    BillingAddressForm.addSubmitListener((billingResponse) => {
        if (!billingResponse.status) {
            BillingAddressForm.showErrors(billingResponse.data);
            BillingAddressForm.turnFormLoadingOff();
        } else {
            loadBillingAddress(() => {
                BillingAddressForm.turnFormLoadingOff();
                BillingAddressForm.emptyForm();
                $('#billingAddressAccordion').collapse('hide');
                loadAdyenDropin();
            });
        }
    });

    $(document).on('click', '.billing-address .add_edit_manage--btn', function () {
        BillingAddressForm.turnFormLoadingOn();
        const id = $(this).attr("data-id");
        const $countrySelect = $('select[name="country"]', BillingAddressForm.form);
        BillingAddressForm.setAction("/billing-address/update/" + id);
        BillingAddressForm.hideDropdown('add_lookuplist');

        BillingAddressForm.populateFields(id, (form, data) => {
            const selectedCountry = $('.selectedCountry', form).val();
            $countrySelect.updateVal(selectedCountry);
            BillingAddressForm.turnFormLoadingOff();
        });
    });

    $(document).on('change', 'select[name="slAccountCode"]', function () {
        loadBillingAddress();
    });
}
